<template>
  <div></div>
</template>
<script setup>
import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { srmquestInvoicePrescription } from "@/api/prescription/prescription";

const route = useRoute();
const router = useRouter();
const state = reactive({
  adviceCode: route.query.a,
  category: route.query.c,
  openid: route.query.openid,
  url: "",
});

if (state.category == 1 || state.category == 2) {
  router.push({
    name: "srmPrescriptionPayments",
    query: {
      openid: state.openid,
      adviceCode: state.adviceCode,
      category: state.category,
    },
  });
} else if (state.category == 3) {
  // 暂定
  router.push({
    name: "advanceSxsrmyyPayment",
  });
}

// if (route.query.code) {
//   router.push({
//     name: "srmPrescriptionPayments",
//     query: {
//       code: route.query.code,
//       adviceCode: state.medicalAdviceCode,
//       category: state.category,
//     },
//   });
// } else {
//   // 获取支付信息接口
//   srmquestInvoicePrescription({
//     adviceCode: state.medicalAdviceCode,
//     category: state.category,
//     url: window.location.href,
//   }).then((v) => {
//     const { data } = v;
//     state.appId = data.wxJsticket.appId;
//     state.url = data.wxJsticket.url;
//     window.location.href =
//       "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
//       state.appId +
//       "&redirect_uri=" +
//       encodeURIComponent(state.url) +
//       "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
//   });
// }
</script>
